import { render, staticRenderFns } from "./share-social-bottom.vue?vue&type=template&id=6266092c&"
import script from "./share-social-bottom.vue?vue&type=script&lang=js&"
export * from "./share-social-bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports